module.exports = __webpack_public_path__ + "static/media/QuoteMachine.dbf5c75e.png";